import { render } from "./StarCircleMessage.vue?vue&type=template&id=38eb26eb&scoped=true&ts=true"
import script from "./StarCircleMessage.vue?vue&type=script&lang=ts"
export * from "./StarCircleMessage.vue?vue&type=script&lang=ts"

import "./StarCircleMessage.vue?vue&type=style&index=0&id=38eb26eb&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38eb26eb"]])

export default __exports__